export function validateIpField(string) {
    const pattern = /^(\d{1,3}\.){3}\d{1,3}(-\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}|(\/\d{1,2})?)$/;

    if (!pattern.test(string)) {
        return false;
    }

    const ipParts = string.split(/[-\/]/)[0].split('.');

    for (const part of ipParts) {
        const num = parseInt(part, 10);
        if (num < 0 || num > 255) {
            return false;
        }
    }

    if (string.includes('-')) {
        const rangeParts = string.split('-')[1].split('.');
        for (const part of rangeParts) {
            const num = parseInt(part, 10);
            if (num < 0 || num > 255) {
                return false;
            }
        }
    }

    if (string.includes('/')) {
        const mask = parseInt(string.split('/')[1], 10);
        if (mask < 0 || mask > 32) {
            return false;
        }
    }

    return true;
};
